<template>
  <div>
        <div class="text-2xl font-bold color-main2">
            <img :src="data.image" />
            {{data.name}}
        </div>

         <div style="color: grey;" class="mt-2">
            <div class="grid grid-cols-2">
                <div class="text-left">{{ data.category_name }}</div>
                <div class="text-right">{{ data.updated_time | toDMY }}</div>
            </div>
        </div>

        <div class="content-detail text-justify mgt-20 mt-4">
            <div v-html="data.content"></div>
        </div>
  </div>
</template>

<script>
export default {
    props: ['data']

}
</script>

<style>

</style>